import { connect } from 'react-redux'
import * as action from '../../state/version-summary/action'
import * as selector from '../../state/version-summary/selector'
import VersionSummary from './VersionSummary'

const mapStateToProps = (state, props) => {
    return {
        versionSummary: selector.selectVersionSummary(state),
        versionSummaryGrouped: selector.selectVersionSummaryGrouped(state),
    }
}

const mapDispatchToProps = {
    getVersionSummary: action.getVersionSummary,
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionSummary)



// WEBPACK FOOTER //
// ./src/modules/process/component/version-summary/VersionSummaryContainer.js